import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class TestAndInspectionsTypesLookupModel extends ModelBase<TestAndInspectionsTypesLookupModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = TestAndInspectionsTypesLookupModel.DEFAULT_ID;

    @observable
    public displayName: string = TestAndInspectionsTypesLookupModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = TestAndInspectionsTypesLookupModel.DEFAULT_ID;
        this.displayName = TestAndInspectionsTypesLookupModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: TestAndInspectionsTypeDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: TestAndInspectionsTypeDTO[]): TestAndInspectionsTypesLookupModel[] {
        const types: TestAndInspectionsTypesLookupModel[] = [];

        for (const dto of dtos) {
            const model = new TestAndInspectionsTypesLookupModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface TestAndInspectionsTypeDTO {
    id: string;
    displayName: string;
}
